import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ClanSearchModal from '../ClanSearchModal/ClanSearchModal.js';

const STRINGS = {
    HOME: gettext("HOME"),
    LEADERBOARD: gettext("LEADERBOARD"),
    FIND_CLAN: gettext("FIND REGIMENT"),
}

function Breadcrumbs({ name }){
    const { clan_db_id } = useParams();
    const [isClanSearchModalOpen, setIsClanSearchModalOpen] = useState(false);

    const openClanSearchModal = () => setIsClanSearchModalOpen(true);
    const closeClanSearchModal = () => setIsClanSearchModalOpen(false);

    return(
        <section>
            <div className="clanleaderboard_border-top"></div>
            <div className="clanleaderboard_spread_contents">
                <div className="clanleaderboard_breadcrumbs">
                    <a href={`/${window.LOCALE}/cms`}>{STRINGS.HOME}</a>
                    &gt;
                    <Link to={`/${window.LOCALE}/clanleaderboard/clans`}>{STRINGS.LEADERBOARD}</Link>
                    { name && clan_db_id ? 
                        (<>
                            &gt;<Link to={`/${window.LOCALE}/clanleaderboard/clan/${clan_db_id}`}>{name.toUpperCase()}</Link>
                        </>): null
                    }
                </div>
                <button className="clanleaderboard_find_clan_button" onClick={openClanSearchModal}>{STRINGS.FIND_CLAN}</button>
                <ClanSearchModal isOpen={isClanSearchModalOpen} onClose={closeClanSearchModal}/>
            </div>
        </section>
    )
}
export default Breadcrumbs;
